module.exports = __webpack_public_path__ + "img/avatar-1.bb0e329d.jpg";